import { Button, Flex, Text } from '@chakra-ui/react';

import Modal from '../../components/Modal';

type LowScoreModalProps = {
  isOpen: boolean;
  rating: number | undefined;
  onFixIt: () => void;
  onConfirm: () => void;
  isConfirming?: boolean;
};

const LowScoreModal = ({
  isOpen,
  rating,
  onFixIt,
  onConfirm,
  isConfirming,
}: LowScoreModalProps) => (
  <Modal isOpen={isOpen} onClose={onFixIt} title="Just double-checking..." size="lg">
    <Flex direction="column" align="center" gap={4} pb={6}>
      <Text textAlign="center" fontSize="lg">
        You rated us {rating ?? 'N/A'} out of 10. That means you had a rough experience. Is that
        right?
      </Text>
      <Button
        w="100%"
        bg="oceanBoatBlue"
        color="white"
        fontWeight="bold"
        fontSize="16px"
        onClick={onFixIt}
        isDisabled={isConfirming}
        _hover={{ transform: 'scale(1.02)', transition: 'all 0.2s ease-in-out' }}
        _active={{ transform: 'scale(0.98)', transition: 'all 0.2s ease-in-out' }}
      >
        Oops, let me fix it
      </Button>
      <Button
        variant="link"
        color="gray.500"
        fontSize="14px"
        onClick={onConfirm}
        isLoading={isConfirming}
        isDisabled={isConfirming}
      >
        Yes, submit it
      </Button>
    </Flex>
  </Modal>
);

export default LowScoreModal;
